// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fixed-float[data-v-44b045f0] {\n  position: fixed;\n  top: 60px;\n}\n", ""]);
// Exports
module.exports = exports;
